export const SERVICE_REQUEST_CREATE_EOC_PARAM = 'createEoc';
export const SERVICE_REQUEST_PATIENT_ID_PARAM = 'patientId';

/** Deep link to Service Request Tracker with the add-episode modal open for a client. */
export function buildServiceRequestCreateEocPath(patientId: string): string {
  const params = new URLSearchParams({
    [SERVICE_REQUEST_CREATE_EOC_PARAM]: '1',
    [SERVICE_REQUEST_PATIENT_ID_PARAM]: patientId,
  });
  return `/dashboard/episode-tracker?${params.toString()}`;
}

export function readServiceRequestCreateEocPatientId(searchParams: URLSearchParams): string | null {
  if (searchParams.get(SERVICE_REQUEST_CREATE_EOC_PARAM) !== '1') return null;
  const patientId = searchParams.get(SERVICE_REQUEST_PATIENT_ID_PARAM)?.trim();
  return patientId || null;
}
